import type React from 'react'
import type { TranslationKey } from '../../i18n'
import type {
  LotStoryArtifactStatus,
  LotStoryArtifactVersionStatus,
  LotStoryArtifactVisibility,
  LotStoryProjectionReadinessStatus
} from '../../types/lotStory'
import type { TranslateFn } from './lotStoryLibraryTypes'

const lotStoryReadinessLabelKey: Record<LotStoryProjectionReadinessStatus, TranslationKey> = {
  ready: 'lots.story.readiness.ready',
  warning: 'lots.story.readiness.warning',
  blocked: 'lots.story.readiness.blocked'
}

const lotStoryArtifactStatusLabelKey: Record<LotStoryArtifactStatus, TranslationKey> = {
  draft: 'lots.story.library.status.draft',
  published: 'lots.story.library.status.published',
  revoked: 'lots.story.library.status.revoked',
  archived: 'lots.story.library.status.archived'
}

const lotStoryArtifactVersionStatusLabelKey: Record<LotStoryArtifactVersionStatus, TranslationKey> = {
  draft: 'lots.story.library.versionStatus.draft',
  published: 'lots.story.library.versionStatus.published',
  superseded: 'lots.story.library.versionStatus.superseded',
  revoked: 'lots.story.library.versionStatus.revoked'
}

const lotStoryArtifactVisibilityLabelKey: Record<LotStoryArtifactVisibility, TranslationKey> = {
  private: 'lots.story.library.visibility.private',
  group: 'lots.story.library.visibility.group'
}

export const getLotStoryReadinessLabel = (t: TranslateFn, status: LotStoryProjectionReadinessStatus): string => (
  t(lotStoryReadinessLabelKey[status])
)

export const getLotStoryArtifactStatusLabel = (t: TranslateFn, status: LotStoryArtifactStatus): string => (
  t(lotStoryArtifactStatusLabelKey[status])
)

export const getLotStoryArtifactVersionLabel = (t: TranslateFn, status: LotStoryArtifactVersionStatus): string => (
  t(lotStoryArtifactVersionStatusLabelKey[status])
)

export const getLotStoryArtifactVisibilityLabel = (t: TranslateFn, visibility: LotStoryArtifactVisibility): string => (
  t(lotStoryArtifactVisibilityLabelKey[visibility])
)

export const getLotStoryReadinessBadgeStyle = (status: LotStoryProjectionReadinessStatus): React.CSSProperties => {
  switch (status) {
    case 'ready':
      return { backgroundColor: '#dcfce7', color: '#166534' }
    case 'warning':
      return { backgroundColor: '#fef3c7', color: '#92400e' }
    case 'blocked':
      return { backgroundColor: '#fee2e2', color: '#b91c1c' }
    default:
      return { backgroundColor: '#e5e7eb', color: '#374151' }
  }
}

export const getLotStoryArtifactStatusBadgeStyle = (status: LotStoryArtifactStatus): React.CSSProperties => {
  switch (status) {
    case 'published':
      return { backgroundColor: '#dcfce7', color: '#166534' }
    case 'draft':
      return { backgroundColor: '#fef3c7', color: '#92400e' }
    case 'revoked':
      return { backgroundColor: '#fee2e2', color: '#b91c1c' }
    default:
      return { backgroundColor: '#e5e7eb', color: '#374151' }
  }
}

export const getLotStoryArtifactVersionBadgeStyle = (status: LotStoryArtifactVersionStatus): React.CSSProperties => {
  switch (status) {
    case 'published':
      return { backgroundColor: '#dcfce7', color: '#166534' }
    case 'draft':
      return { backgroundColor: '#fef3c7', color: '#92400e' }
    case 'revoked':
      return { backgroundColor: '#fee2e2', color: '#b91c1c' }
    default:
      return { backgroundColor: '#e2e8f0', color: '#475569' }
  }
}